import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EmailToSupplier.ResendQuote', {
    resendButton: 'Re-send a Quote',
    quoteWasSuccessfullyResent: 'The quote was successfully re-sent.',
});
